import React from "react";
import { browserHistory } from "react-router";
import Dialog from "rc-dialog";
import StudentPresent from "../components/StudentPresent";
import StudentPresentAdd from "../components/StudentPresentAdd";
import axios from "axios";
import moment from "moment";
import { getDeep } from "../components/Utils";

import "rc-dialog/assets/bootstrap.css";

export default class EventsDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allStudentsPresent: false,
      dialogVisible: false,
      dialogConfirmationVisible: false,
      studentFormVisible: false,
      showAlertNoStudents: false,
      showAlertNoCheckbox: false,
      sendMeasurementsInfo: "",
      sendMeasurementsAlert: "",
      instructorsPresent: [localStorage.userUUID],
      checkbox1: false,
      courseExemptions: []
    };
  }

  handleStart = (link) => {
    // Check if we have at least one student
    if (this.props.students && this.props.students[this.props.params.eventId] && this.props.students[this.props.params.eventId].length == 0) {
      this.setState({
        showAlertNoStudents: true
      });
    } else {
      // Make a checklist of all the required measurements
      let currentEvent = this.props.events[this.props.params.eventId];

      if (getDeep(currentEvent, "event_roles")) {
        currentEvent.event_roles.forEach((eventRole) => {
          eventRole.students
            .filter((s) => !s.cancelled)
            .forEach((student) => {
              eventRole.end_terms.forEach((endterm) => {
                endterm.competences.forEach((competence) => {
                  let comp = competence.competence;

                  // Loop only through the competences that have a practice measurement
                  if (competence.bundles.find((b) => b.measurements.find((m) => m.measurement_type == "practice"))) {
                    this.props.addMeasurement(currentEvent.uuid, student.uuid, student.uuid + "-comp-" + comp.uuid, 0);

                    competence.bundles.forEach((bundle) => {
                      this.props.addMeasurement(currentEvent.uuid, student.uuid, "bundle-" + student.uuid + "-" + comp.uuid + "-" + bundle.uuid, 0);

                      bundle.measurements.forEach((measurement) => {
                        if (measurement.measurement_type == "practice") {
                          this.props.addMeasurement(currentEvent.uuid, student.uuid, measurement.uuid, 0);
                        }
                      });
                    });
                  }
                });
              });
            });
        });
      }

      browserHistory.push(link);
    }
  };

  handlePresentChange = (present) => {
    this.checkStudentsPresent();
  };

  handleInstructorPresentChange = (e) => {
    let instructorsPresent = this.state.instructorsPresent;
    if (instructorsPresent.includes(e.target.value)) {
      instructorsPresent = instructorsPresent.filter((present) => present !== e.target.value);
    } else {
      instructorsPresent.push(e.target.value);
    }
    this.setState({
      instructorsPresent
    });
  };

  handleAlertClose = () => {
    this.setState({
      showAlertNoStudents: false,
      showAlertNoCheckbox: false,
      sendMeasurementsAlert: "",
      sendMeasurementsInfo: ""
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogVisible: false
    });
  };

  handleCheckbox = (elem) => {
    this.setState({
      [elem]: !this.state[elem],
      showAlertNoCheckbox: true
    });
    this.handleAlertClose();
  };

  handleDialogOpen = () => {
    // Check if we have at least one student
    let checker = this.props.params.eventId + "-";
    let counterArray = 0;
    if (this.props.students && this.props.students[this.props.params.eventId] && this.props.students[this.props.params.eventId].length) {
      counterArray = this.props.students[this.props.params.eventId].length;
    }

    if (counterArray === 0) {
      this.setState({
        showAlertNoStudents: true
      });
    } else {
      this.setState({
        dialogVisible: true
      });
    }
  };

  handleStudentFormClose = () => {
    this.setState({
      studentFormVisible: false
    });
  };

  handleStudentFormOpen = () => {
    this.setState({
      studentFormVisible: true
    });
  };

  checkStudentsPresent = () => {
    // Check if all the students are present
    let studentsPresent = 0;
    let currentEvent = this.props.events[this.props.params.eventId];

    if (currentEvent !== undefined) {
      if (currentEvent.event_roles !== undefined) {
        currentEvent.event_roles.forEach((eventRole) => {
          eventRole.students
            .filter((s) => !s.cancelled)
            .forEach((student) => {
              if (student.will_attend) {
                studentsPresent++;
              }
            });
        });

        let allStudentsPresent = false;
        if (this.props.students[this.props.params.eventId] !== undefined) {
          allStudentsPresent = studentsPresent === this.props.students[this.props.params.eventId].length;
        }

        this.setState({
          allStudentsPresent
        });

        if (getDeep(this.props.students, [this.props.params.eventId]) && this.state.showAlertNoStudents) {
          this.setState({
            showAlertNoStudents: false
          });
        }
      }
    }
  };

  handleSaveEvent = () => {
    if (this.refs.checkbox1.checked) {
      // Both checked, allow saving the event
      let sendMeasurements = [];

      let eventDetails = getDeep(this.props.measurements, this.props.params.eventId);

      if (eventDetails !== undefined) {
        let currentEvent = this.props.events[this.props.params.eventId];
        Object.keys(eventDetails).forEach((studentId) => {
          if (this.props.students[this.props.params.eventId].includes(studentId)) {
            let student = eventDetails[studentId];

            Object.keys(student).forEach((measurementId) => {
              let measurement = student[measurementId];

              currentEvent.event_roles.forEach((eventRole) => {
                eventRole.end_terms.forEach((endterm) => {
                  endterm.competences.forEach((comp) => {
                    comp.bundles.forEach((bundle) => {
                      bundle.measurements.forEach((meas) => {
                        let checkEx = this.state.courseExemptions.find(
                          (ex) => ex.end_term === endterm.end_term.uuid && ex.user === studentId && ex.course === currentEvent.course
                        );

                        if (!checkEx && this.props.students[this.props.params.eventId].includes(studentId)) {
                          if (meas.uuid == measurementId && measurement != 0 && !measurementId.includes("bundle") && !measurementId.includes("comp")) {
                            let newMeasurement = {
                              measurement: measurementId,
                              user: studentId,
                              score_type: parseInt(measurement)
                            };
                            sendMeasurements.push(newMeasurement);
                          }
                        }
                      });
                    });
                  });
                });
              });
            });
          }
        });

        this.setState({
          sendMeasurementsInfo: "Bezig met het verzenden van de toetsingen...",
          sendMeasurementsAlert: ""
        });

        let requests = [];

        // Update the students to let the system know they attended
        let updateStudent = {};
        Object.keys(eventDetails).forEach((studentId) => {
          if (this.props.students[this.props.params.eventId].includes(studentId)) {
            updateStudent = {
              attended: true
            };

            // Find the event role for this student:
            const studentEventRole = this.props.events[this.props.params.eventId].event_roles.find((role) => {
              // if the role contains this student we have found our role!
              return role.students.filter((s) => !s.cancelled).find((student) => student.uuid === studentId);
            });

            if (studentEventRole) {
              requests.push(
                axios
                  .patch("/v1/events/" + this.props.params.eventId + "/eventroles/" + studentEventRole.uuid + "/students/" + studentId + "/", updateStudent)
                  .catch(function (err) {
                    console.warn("API Error: Updating student after finishing an event did not succeed, student ID: " + studentId, err);
                  })
              );
            } else {
              console.warn(`Could not determine the role for student ${studentId}`);
            }
          }
        });

        // Update instructors that were present
        if (currentEvent) {
          currentEvent.event_roles.forEach((role) => {
            this.state.instructorsPresent.forEach((uuid) => {
              requests.push(
                axios
                  .patch(`/v1/events/${this.props.params.eventId}/eventroles/${role.uuid}/instructors/${uuid}/`, {
                    attended: true
                  })
                  .catch((err) => {
                    console.warn("API Error: Updating nistructor after finishing an event did not succeed, instructor ID: " + uuid, err);
                  })
              );
            });
          });
        }

        axios
          .all(requests)
          .then((results) => {
            axios
              .post("/v1/events/" + this.props.params.eventId + "/results/", sendMeasurements)
              .then((response) => {
                if (response.data) {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: "",
                    dialogConfirmationVisible: true
                  });
                  this.handleDialogClose();
                }
              })
              .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.detail) {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: <span>{err.response.data.detail}</span>
                  });
                } else {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: (
                      <span>
                        De resultaten zijn helaas niet goed verzonden.
                        <br />
                        Neem contact op met NIBHV op 010 - 289 28 88.
                        <br />
                        Klik op annuleren om terug te keren naar het toetsmoment.
                      </span>
                    )
                  });
                }
                console.warn("API Error: Sending results did not succeed", err);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.setState({
          sendMeasurementsAlert: "Er zijn nog geen toetsresultaten ingevuld"
        });
      }
    } else {
      this.setState({
        showAlertNoCheckbox: true
      });
    }
  };

  handleDialogConfirmationClose = () => {
    this.setState({
      dialogConfirmationVisible: false
    });
    this.props.fetchEvents();
    browserHistory.push("/");
  };

  togglePresenceAll = () => {
    let allStudentsPresent = !this.state.allStudentsPresent;
    let currentEvent = this.props.events[this.props.params.eventId];
    let studentsPresent = 0;

    if (getDeep(currentEvent, "event_roles")) {
      currentEvent.event_roles.forEach((eventRole) => {
        eventRole.students
          .filter((s) => !s.cancelled)
          .forEach((student) => {
            if (student.will_attend) {
              if (
                allStudentsPresent &&
                this.props.students[this.props.params.eventId] !== undefined &&
                !this.props.students[this.props.params.eventId].includes(student.uuid)
              ) {
                studentsPresent++;
                this.props.toggleStudentPresence(this.props.params.eventId, student.uuid);
              }
              if (
                !allStudentsPresent &&
                this.props.students[this.props.params.eventId] !== undefined &&
                this.props.students[this.props.params.eventId].includes(student.uuid)
              ) {
                this.props.toggleStudentPresence(this.props.params.eventId, student.uuid);
              }
            }
          });
      });

      this.setState({
        allStudentsPresent
      });
    }
  };

  componentDidUpdate() {
    if (this.props.events[this.props.params.eventId] && !this.props.events[this.props.params.eventId].loading_details) {
      this.props.fetchEventDetails(this.props.params.eventId);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.initStudentsForEvent(this.props.params.eventId);
      this.checkStudentsPresent();
    }, 1000);
  }

  componentWillMount() {
    if (this.props.events === undefined || this.props.events.length === 0) {
      this.props.fetchEvents();
    }
    // Get all exemptions for this course
    axios
      .get(`/v1/events/${this.props.params.eventId}/exemptions/?pagination=false&fields=user,course,competence_profile,end_term`)
      .then((response) => {
        this.setState({
          courseExemptions: response.data
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    if (this.props.events.length === 0) {
      return (
        <div className="alert alert-info" key="uniquep">
          Ophalen van toetsmoment details...
        </div>
      );
    }

    let currentEvent = this.props.events[this.props.params.eventId];
    if (currentEvent === undefined) {
      return (
        <div className="alert alert-info" key="uniquep">
          Ophalen van toetsmoment details...
        </div>
      );
    }

    let measurementLink = "/events/" + this.props.params.eventId + "/measurements";
    let newStudentLink = "/events/" + this.props.params.eventId + "/student/new";

    let students = [];
    let instructors = [];
    let usedStudents = [];
    let lastId = 0;
    let employerName = "";
    let toggleType = (
      <span>
        <i className="fa fa-toggle-off"></i> Zet elke cursist op aanwezig <i className="fa fa-thumbs-o-up"></i>
      </span>
    );
    let unfinishedStudents = [];
    let unfinishedCompetences = {};

    if (currentEvent !== undefined && currentEvent.event_roles !== undefined) {
      if (this.state.allStudentsPresent) {
        toggleType = (
          <span>
            <i className="fa fa-toggle-on"></i> Zet elke cursist op afwezig
          </span>
        );
      }
      employerName = currentEvent.description;

      let finishedStudents = 0;

      currentEvent.event_roles.forEach((eventRole) => {
        eventRole.students
          .filter((s) => !s.cancelled)
          .forEach((student) => {
            if (student.will_attend) {
              // Check percentage
              let studentUnfinishedCompetences = new Set();
              let measurementsTotal = 0;
              let measurementsDone = 0;
              let tempObject = getDeep(this.props.measurements, this.props.params.eventId, student.uuid);

              // Get the measurements that are under the active student
              if (tempObject !== undefined && tempObject !== null) {
                Object.keys(tempObject).forEach((key) => {
                  // Check measurements with results
                  let checkUUID = key.toString();

                  if (!checkUUID.includes("bundle") && !checkUUID.includes("comp")) {
                    measurementsTotal++;

                    // Only mark a measurement as done if it has a result more than 0
                    if (tempObject[key] > 0) {
                      measurementsDone++;
                    } else {
                      // Find the related competence UUID for the unfinished measurement
                      let relatedCompetenceUUID = null;
                      for (const endTerm of eventRole.end_terms) {
                        for (const competence of endTerm.competences) {
                          for (const bundle of competence.bundles) {
                            for (const measurement of bundle.measurements) {
                              if (measurement.uuid === key) {
                                relatedCompetenceUUID = competence.competence;
                                break;
                              }
                            }
                            if (relatedCompetenceUUID) break;
                          }
                          if (relatedCompetenceUUID) break;
                        }
                        if (relatedCompetenceUUID) break;
                      }
                      studentUnfinishedCompetences.add(relatedCompetenceUUID);
                    }
                  }
                });
              }

              // Check for exemptions for this student
              eventRole.end_terms.forEach((endterm) => {
                let checkEx = this.state.courseExemptions.find(
                  (ex) => ex.end_term === endterm.end_term.uuid && ex.user === student.uuid && ex.course === currentEvent.course
                );
                if (checkEx) {
                  endterm.competences.forEach((comp) => {
                    comp.bundles.forEach((bundle) => {
                      measurementsTotal -= bundle.measurements.length;
                    });
                  });
                }
              });

              let percentage = Math.round((measurementsDone / measurementsTotal) * 100);

              if (measurementsTotal === 0) {
                percentage = 0;
              } else if (
                percentage < 100 &&
                this.props.students &&
                this.props.students[this.props.params.eventId] &&
                this.props.students[this.props.params.eventId].includes(student.uuid)
              ) {
                unfinishedCompetences[student.uuid] = Array.from(studentUnfinishedCompetences);
                unfinishedStudents.push(student);
              }

              if (usedStudents[currentEvent.uuid + "-" + student.uuid] === undefined) {
                let studentRow = (
                  <StudentPresent
                    {...this.props}
                    key={currentEvent.uuid + "-" + student.uuid + "-" + lastId}
                    uuid={student.uuid}
                    eventId={currentEvent.uuid}
                    student={student}
                    student_role={eventRole}
                    percentage={percentage}
                    roles={currentEvent.event_roles}
                    callbackParent={this.handlePresentChange}
                  />
                );
                usedStudents[currentEvent.uuid + "-" + student.uuid] = true;
                students.push(studentRow);
              }
              lastId++;
            }
          });
        eventRole.instructor_details.forEach((instructor) => {
          instructors.push({
            uuid: instructor.uuid,
            name: instructor.full_name
          });
        });
      });

      // Disabled for now, since adding a student has a lot of complicated challenges
      // let studentRow = (
      //     <StudentPresentAdd
      //         {...this.props}
      //         key="unique"
      //         roles={currentEvent.event_roles}
      //     />
      // );
      // students.push(studentRow);
    } else {
      students.push(
        <div className="alert alert-info" key="uniquep">
          Ophalen van cursisten...
        </div>
      );
    }

    let errorNoStudents = "";
    if (this.state.showAlertNoStudents) {
      errorNoStudents = <div className="alert alert-info">Er zijn nog geen kandidaten als aanwezig gemarkeerd</div>;
    }

    let finalizeCheckboxError = "";
    if (this.state.showAlertNoCheckbox) {
      finalizeCheckboxError = <div className="alert alert-info">Vink het bovenstaande vakje aan voordat je de resultaten van het toetsmoment instuurt</div>;
    }

    let unfinishedWarning = false;
    let warningStudents = [];
    let i = 0;

    Object.keys(unfinishedStudents).forEach((key) => {
      let student = unfinishedStudents[key];
      warningStudents.push(
        <div key={"warning" + student.uuid + i++}>
          - {student.first_name} {student.last_name_prefix} {student.last_name}
          {Object.keys(unfinishedCompetences).map((key) => {
            if (key === student.uuid) {
              return (
                <ul key={student.uuid}>
                  {unfinishedCompetences[key].map((comp) => {
                    return (
                      <li className="unfinished-competence" key={comp.uuid}>
                        {comp.name}
                      </li>
                    );
                  })}
                </ul>
              );
            }
          })}
        </div>
      );
    });

    if (warningStudents.length > 0) {
      unfinishedWarning = (
        <div className="alert alert-danger" key="unfinishedwarning">
          <p>De volgende deelnemers hebben nog niet alle resultaten onder hun competenties ingevuld staan:</p>
          {warningStudents}
          <br />
          Vul deze resultaten aan voordat ze ingestuurd worden. Als niet alle competenties resultaten hebben kan er niet ingestuurd worden.
        </div>
      );
    }

    let sendMeasurementsInfo = "";
    if (this.state.sendMeasurementsInfo != "") {
      sendMeasurementsInfo = (
        <div className="alert alert-info" key="measurementinfo">
          {this.state.sendMeasurementsInfo}
        </div>
      );
    }

    let sendMeasurementsAlert = "";
    if (this.state.sendMeasurementsAlert != "") {
      sendMeasurementsAlert = (
        <div className="alert alert-danger" key="measurementalert">
          {this.state.sendMeasurementsAlert}
        </div>
      );
    }

    let presentInfo = "";
    if (instructors.length >= 1) {
      presentInfo = (
        <div className="present-info">
          <p>Beste {localStorage.userFirstName},</p>
          <p>
            Voor dit toetsmoment beoordeel je gezamenlijk/in overleg de cursisten. Slechts één instructeur (de hoofdinstructeur) kan de resultaten insturen naar NIBHV;
          </p>
          <ul>
            <li>Bepaal wie de hoofdinstructeur van deze cursus is</li>
            <li>
              Geef als hoofdinstructeur bij het insturen van de resultaten aan wie de hoofdinstructeur was en wie de overige aanwezige instructeurs van dit toetsmoment
              waren
            </li>
            <li>
              De hoofdinstructeur stuurt <strong>binnen 24 uur</strong> na het toetsmoment de uiteindelijke resultaten naar NIBHV
            </li>
          </ul>
        </div>
      );
    }

    let otherInstructors = [];
    instructors.forEach((instructor) => {
      if (instructor.uuid !== localStorage.userUUID) {
        otherInstructors.push(
          <div className="custom-control custom-checkbox event-dialog-checkbox" key={`instructor-${instructor.uuid}`}>
            <input
              className="custom-control-input"
              type="checkbox"
              ref={`instructor-${instructor.uuid}`}
              id={`instructor-${instructor.uuid}`}
              checked={this.state.instructorsPresent.includes(instructor.uuid)}
              value={instructor.uuid}
              onChange={this.handleInstructorPresentChange}
            />
            <label className="custom-control-label custom-control-description" htmlFor={`instructor-${instructor.uuid}`}>
              {instructor.name}{" "}
            </label>
          </div>
        );
      }
    });

    let allowedContent = (
      <div className="intro">
        {errorNoStudents}
        <button
          className="btn btn-large btn-primary"
          onClick={() => {
            this.handleStart(measurementLink);
          }}
        >
          Bekijk alvast de toetsingen
        </button>
      </div>
    );
    if (moment().isAfter(currentEvent.start_datetime)) {
      // Starttime has passed, allowed to send in
      allowedContent = (
        <div className="intro">
          {errorNoStudents}
          <button
            className="btn btn-large btn-primary"
            onClick={() => {
              this.handleStart(measurementLink);
            }}
          >
            Start praktijktoets
          </button>{" "}
          <button
            className="btn btn-large btn-primary"
            onClick={() => {
              this.handleDialogOpen();
            }}
          >
            Insturen resultaten
          </button>
        </div>
      );
    }

    return (
      <div className="students-present">
        <div className="intro">
          <h1>{currentEvent.name}</h1>
          <h2>{employerName}</h2>
          <p>{currentEvent.description}</p>
          <div className="alert alert-info">
            Hier geef je aan welke cursisten aanwezig zijn op dit toetsmoment.
            <br />
            Mis je een cursist? Neem dan contact op met de opleider. Zij kunnen de cursist alsnog toevoegen aan dit toetsmoment.
          </div>
          <button className="btn btn-large btn-primary" onClick={this.togglePresenceAll}>
            {toggleType}
          </button>
        </div>

        <div className="present-container">{students}</div>

        {presentInfo}

        {allowedContent}

        <Dialog
          title="Insturen van de resultaten"
          onClose={this.handleDialogClose}
          animation="fade"
          visible={this.state.dialogVisible}
          key="sendmeasurementsdialog"
          footer={[
            <button type="button" className="btn btn-secondary" key="close" onClick={this.handleDialogClose}>
              Annuleren
            </button>,
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleSaveEvent} disabled={unfinishedWarning !== false}>
              Opslaan en insturen
            </button>
          ]}
        >
          <p>
            <strong>Insturen van de resultaten (binnen 24 uur)</strong>
            <br />
            De ingevulde competentieresultaten van de cursisten moeten binnen 24 uur na het toetsmoment verstuurd worden naar NIBHV. Dit specifieke toetsmoment verdwijnt
            vervolgens automatisch uit deze tool.
          </p>

          {unfinishedWarning}

          <hr />

          <p>De volgende instructeurs zijn aanwezig geweest op dit toetsmoment:</p>
          <div className="custom-control custom-checkbox event-dialog-checkbox" key="main-instructor">
            <input className="custom-control-input" type="checkbox" ref="main-instructor" id="main-instructor" checked={true} disabled={true} />
            <label className="custom-control-label custom-control-description" htmlFor="main-instructor">
              {localStorage.userName || "U"} (hoofdinstructeur)
            </label>
          </div>
          {otherInstructors}

          <hr />

          <div className="custom-control custom-checkbox event-dialog-checkbox" key="checkbox1">
            <input
              className="custom-control-input"
              type="checkbox"
              ref="checkbox1"
              id="checkbox1"
              checked={this.state.checkbox1}
              onChange={() => this.handleCheckbox("checkbox1")}
            />
            <label className="custom-control-label custom-control-description" htmlFor="checkbox1">
              Bovenstaande instructeurs hebben alle cursisten van dit toetsmoment beoordeeld op de competenties en toetsingen.
            </label>
          </div>
          {this.state.checkbox1 ? <div></div> : ""}
          {finalizeCheckboxError}

          {sendMeasurementsInfo}
          {sendMeasurementsAlert}
        </Dialog>

        <Dialog
          title="Insturen van de resultaten"
          onClose={this.handleDialogConfirmationClose}
          animation="fade"
          visible={this.state.dialogConfirmationVisible}
          key="sentmeasurementsdialog"
          footer={[
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleDialogConfirmationClose}>
              Terug naar het overzicht
            </button>
          ]}
        >
          <p>
            De ingevulde competentieresultaten zijn succesvol verstuurd naar NIBHV en worden verwerkt. Dit specifieke toetsmoment verdwijnt automatisch uit deze tool. Je
            gaat nu terug naar het overzicht van de toetsmomenten.
          </p>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/EventsDetail.js